import { cn } from "@/lib/utils";
import React from "react";

export const Marquee = ({
  items,
  direction = "left",
  speed = "fast",
  pauseOnHover = true,
  className,
}: {
  items: React.ReactNode[];
  direction?: "left" | "right";
  speed?: "fast" | "normal" | "slow";
  pauseOnHover?: boolean;
  className?: string;
}) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const scrollerRef = React.useRef<HTMLUListElement>(null);

  React.useEffect(() => {
    addAnimation();
  }, []);

  const [start, setStart] = React.useState(false);

  function addAnimation() {
    if (containerRef.current && scrollerRef.current) {
      const scrollerContent = Array.from(scrollerRef.current.children);

      scrollerContent.forEach((item) => {
        const duplicatedItem = item.cloneNode(true);
        if (scrollerRef.current) {
          scrollerRef.current.appendChild(duplicatedItem);
        }
      });

      setStart(true);
    }
  }

  const durationMap = {
    fast: "80s",
    normal: "200s",
    slow: "400s",
  };

  const directionStyle = {
    "--animation-direction": direction === "left" ? "forwards" : "reverse",
  } as React.CSSProperties;

  const durationStyle = {
    "--animation-duration": durationMap[speed],
    animationDuration: durationMap[speed],
  } as React.CSSProperties;

  return (
    <div
      ref={containerRef}
      style={directionStyle}
      className={cn(
        "scroller relative z-20 w-full overflow-hidden mask-linear-to-r from-transparent via-white to-transparent",
        className
      )}
    >
      <ul
        ref={scrollerRef}
        style={durationStyle}
        className={cn(
          "flex min-w-full shrink-0 gap-6 py-6 w-max flex-nowrap",
          start && "animate-marquee",
          pauseOnHover && "hover:[animation-play-state:paused]"
        )}
      >
        {items.map((item, idx) => (
          <li
            className="w-[300px] max-w-full relative rounded-2xl border border-white/10 flex-shrink-0 bg-obsidian-100/80 px-8 py-6 md:w-[400px]"
            key={idx}
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
